import React from 'react';
import RootRouter from "routes/RootRouter";

function App() {
  return (
    <RootRouter />
  );
}

export default App;
